import { Week } from '../models/week';
import { TimecardRow } from '../models/timecardrow';
import { ApiTimecard, ApiTimecardDay } from '../models/apiTimecard';
import { ApiTemplateRow, ApiTemplate } from '../models/apiTemplate';
import { Project } from '../models/project';
import { Task } from '../models/task';
import { Template } from '../models/template';

const applicationTimeZone = { timeZone: 'Europe/Stockholm' };

export class Converters {
    static ApiTemplateToTemplate(apiTemplateArray: ApiTemplate[]): Template[] {

        let templateArray = new Array<Template>();

        for (let apiTemplate of apiTemplateArray) {
            let template = new Template();
            template.name = apiTemplate.name;

            for (let apiTemplateRow of apiTemplate.templateList) {
                let timecardRow = new TimecardRow;

                timecardRow.project = new Project();
                timecardRow.project.projNo = apiTemplateRow.projNo;
                timecardRow.project.projName = apiTemplateRow.projName;

                timecardRow.task = new Task();
                timecardRow.task.taskNo = apiTemplateRow.taskNo;
                timecardRow.task.taskName = apiTemplateRow.taskName;
                timecardRow.task.startDt = apiTemplateRow.startDt;
                timecardRow.task.endDt = apiTemplateRow.endDt;
                timecardRow.task.expType = apiTemplateRow.expType;
                timecardRow.project.tasks = new Array<Task>();
                timecardRow.project.tasks.push(timecardRow.task);

                timecardRow.mon = apiTemplateRow.mon.toString();
                timecardRow.tue = apiTemplateRow.tue.toString();
                timecardRow.wed = apiTemplateRow.wed.toString();
                timecardRow.thu = apiTemplateRow.thu.toString();
                timecardRow.fri = apiTemplateRow.fri.toString();
                timecardRow.sat = apiTemplateRow.sat.toString();
                timecardRow.sun = apiTemplateRow.sun.toString();

                template.timeCardRows.push(timecardRow);
            }
            templateArray.push(template);
        }

        return templateArray;
    }

    static TimeCardRowToApiTemplate(email: string, templateName: string, timeCardRows: TimecardRow[]): ApiTemplate[]{
        let apiTemplate = new ApiTemplate();
        apiTemplate.name = templateName;

        for (let timeCardRow of timeCardRows) {
            let apiTemplateRow = new ApiTemplateRow();

            apiTemplateRow.tempId = "";
            apiTemplateRow.email = email;
            apiTemplateRow.projNo = timeCardRow.project.projNo;
            apiTemplateRow.projName = timeCardRow.project.projName;
            apiTemplateRow.taskNo = timeCardRow.task.taskNo;
            apiTemplateRow.taskName = timeCardRow.task.taskName;
            apiTemplateRow.expType = timeCardRow.task.expType;
            apiTemplateRow.startDt = timeCardRow.task.startDt;
            apiTemplateRow.endDt = timeCardRow.task.endDt;
            apiTemplateRow.mon = Number(timeCardRow.mon );
            apiTemplateRow.tue = Number(timeCardRow.tue );
            apiTemplateRow.wed = Number(timeCardRow.wed );
            apiTemplateRow.thu = Number(timeCardRow.thu );
            apiTemplateRow.fri = Number(timeCardRow.fri );
            apiTemplateRow.sat = Number(timeCardRow.sat );
            apiTemplateRow.sun = Number(timeCardRow.sun );
            apiTemplateRow.name = templateName;

            apiTemplate.templateList.push(apiTemplateRow);
        }

        let apiTemplates = new Array<ApiTemplate>();
        apiTemplates.push(apiTemplate);
        return apiTemplates;
    }

    static fromWeek(username: string, week: Week, timeCardRows: Array<TimecardRow>) {
        var apiTimeCard = new ApiTimecard();
        apiTimeCard.email = username;
        apiTimeCard.weekNo = week.weekNo;
        apiTimeCard.timeCardId = week.timeCardId;
        apiTimeCard.status = week.status.toLowerCase();
        apiTimeCard.empComment = week.timeCard.empComment;

        apiTimeCard.taskDays = new Array<ApiTimecardDay>();
        let sortOrder = 0;
        for (let timecardRow of timeCardRows) {
            for (let weekDayCount = 0; weekDayCount < 7; weekDayCount++) {
                apiTimeCard.taskDays.push( this.dayProjTaskHours(timecardRow, new Date(week.firstDayOfWeek), sortOrder++, weekDayCount) );
            }
        }
        return apiTimeCard;
    }

    private static dayProjTaskHours(timecardRow: TimecardRow, firstDayOfWeek: Date, sortOrder: number, weekDay: number ): ApiTimecardDay  {
        let dayDate = new Date(firstDayOfWeek);
        dayDate.setDate(dayDate.getDate() + weekDay);
        dayDate.setHours(12,0,0);

        let apiTimecardDay = new ApiTimecardDay();
        apiTimecardDay.day = dayDate;
        apiTimecardDay.hours = Number( this.getHours(timecardRow, weekDay) );
        apiTimecardDay.timeId = this.getTimeId(timecardRow, weekDay);
        apiTimecardDay.expType = timecardRow.task.expType;
        apiTimecardDay.projNo = timecardRow.project.projNo;
        apiTimecardDay.taskNo = timecardRow.task.taskNo;
        apiTimecardDay.rowOrder = sortOrder;
        return apiTimecardDay;
    }

    private static getHours(timecardRow: TimecardRow, weekDay: number): string {
        switch (weekDay) {
            case 0: return timecardRow.mon == null || timecardRow.mon == '' ? '0' : timecardRow.mon;
            case 1: return timecardRow.tue == null || timecardRow.tue == '' ? '0' : timecardRow.tue;
            case 2: return timecardRow.wed == null || timecardRow.wed == '' ? '0' : timecardRow.wed;
            case 3: return timecardRow.thu == null || timecardRow.thu == '' ? '0' : timecardRow.thu;
            case 4: return timecardRow.fri == null || timecardRow.fri == '' ? '0' : timecardRow.fri;
            case 5: return timecardRow.sat == null || timecardRow.sat == '' ? '0' : timecardRow.sat;
            case 6: return timecardRow.sun == null || timecardRow.sun == '' ? '0' : timecardRow.sun;
            default: return '';
        }
    }    
    
    private static getTimeId(timecardRow: TimecardRow, weekDay: number): number {
        switch (weekDay) {
            case 0: return timecardRow.monId;
            case 1: return timecardRow.tueId;
            case 2: return timecardRow.wedId;
            case 3: return timecardRow.thuId;
            case 4: return timecardRow.friId;
            case 5: return timecardRow.satId;
            case 6: return timecardRow.sunId;
            default: return -1;
        }
    }
}